import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@services/api.service';

export function withdrawLimitValidator(
  http: HttpClient,
  api: ApiService,
  originCurrency: string,
  destinationCurrency: string,
): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const amount = control.value;
    if (!amount) {
      return of(null);
    }

    return http.get<any>(`/assets/json/payoutsLimit.json`).pipe(
      switchMap((payoutsLimit: any) => {
        if (payoutsLimit[destinationCurrency]) {
          return api
            .post('v1/public/rate', {
              srcCurrency: originCurrency,
              dstCurrency:
                payoutsLimit[destinationCurrency].min?.currency ??
                payoutsLimit[destinationCurrency].max?.currency,
              amount: amount,
            })
            .pipe(
              map((rate: any) => {
                if (
                  payoutsLimit[destinationCurrency].min &&
                  rate.record.amount <
                    payoutsLimit[destinationCurrency].min.value
                ) {
                  return {
                    minAmount: `${(
                      (1 / rate.record.rate) *
                      payoutsLimit[destinationCurrency].min.value
                    ).toFixed(2)} ${originCurrency}`,
                  };
                }

                if (
                  payoutsLimit[destinationCurrency].max &&
                  rate.record.amount >
                    payoutsLimit[destinationCurrency].max.value
                ) {
                  return {
                    maxAmount: `${(
                      (1 / rate.record.rate) *
                      payoutsLimit[destinationCurrency].max.value
                    ).toFixed(2)} ${originCurrency}`,
                  };
                }

                return null;
              }),
            );
        }
        return of(null);
      }),
      catchError(() => of(null)),
    );
  };
}
